module.exports = __webpack_public_path__ + "img/service_main02.83a3ae77.png";